import axios from "axios";
import server_config from '../../ServerConfiguration';
const fevir_node_server_address = server_config["fevir_node_server_address"];

const saveSearch = async (apiToken, source, searchString, searchParameters = null, label = "", autocheck = true, searched = false) => { //This function will be moved to a separate API file for other pages to use
    if (!searchString && !searchParameters) {
        console.log("no searchstring and no searchParameters");
        return null;
    }
    label = label || prompt("Please enter a label for your saved search.", ""); //For now instead of a modal
    console.log("CALLING SERVER with addsavedsearch")
    let response = await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 5000,
        data: {
            'functionid': 'addsavedsearch',
            'apiToken': apiToken,
            'label': label,
            'source': source,
            'searchstring': searchString,
            'searchparameters': searchParameters,
            'autocheck': autocheck ?? true,
            'searched': searched
            //'lastcheckeddate': lastCheckedDateTime
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from addsavedsearch call");
    }).catch((error) => { console.log(error); });
    return response;
}

const updateSearch = async (apiToken, searchid = null, searchData = {}) => {
    console.log("updatesavedsearch call");
    let queryData = {
        'functionid': 'updatesavedsearch',
        'apiToken': apiToken,
        'searchid': searchid || searchData.id,
        ...searchData
    };
    let response = await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 20000,
        data: queryData,
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from updatesavedsearch call");
    }).catch((error) => { console.log(error); });
    return response;
}

const loadSavedSearches = async (apiToken) => {
    console.log("getusersavedsearches call");
    let response = await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 20000,
        data: {
            'functionid': 'getusersavedsearches',
            'apiToken': apiToken
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from getusersavedsearches call");
    }).catch((error) => { console.log(error); });
    return response;
}

export { saveSearch, updateSearch, loadSavedSearches };